angular.module('dpw.components')
    .component('dpwTryAndServiceButtons', {
        templateUrl: 'dpw-try-and-service-buttons.html',
        controller: ['mixpanelService', function (mixpanelService) {
            this.isVisible = !RCDPW.isLogin;
            mixpanelService.track_links('.try-and-service-buttons-tryForFree', mixpanelService.eventNames.SIGNUP_BUTTON_CLICK, {
                'Signup Entry': 'Try for free'
            });
            mixpanelService.track_links('.try-and-service-buttons-plan', mixpanelService.eventNames.ACTION, {
                'Action Name': 'Plans and pricing'
            });
        }]
    });
